import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "題目",
    isNumber: true,
    isSum: true,
    isControl: true,
  },
  {
    key: "選項",
    isNumber: true,
    isSum: true,
  },
];

export const VillageToWeightWaistManagement = {
  label: "鄉鎮 vs 體重及腰圍管理",
  key: "VillageToWeightWaistManagement",
  path: "BMI/VillageToWeightWaistManagement",
  api: "TCS_V_BMIHEBMIV",
  render: (options) => (
    <Diagram.BMI.VillageToWeightWaistManagement {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "鄉鎮",
      field: "鄉鎮",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
